import React from "react";
import '../cssfiles/loginpage.css'
import mainimage from '../images/Main.png';
import brand from '../images/Brand.png';
import smartcommlogo from '../images/Smartcommlogo.png';
import brandimage1 from "../images/brand1.png";
import brandimage2 from "../images/brand2.png";
import brandimage3 from "../images/brand3.png";
import brandimage4 from "../images/brand4.png";
import brandimage5 from "../images/brand5.png";
import { Typography } from "@mui/material";

export default function Loginpageleftimage () {
    return(
        <div>
            <div style={{width: '100%', height: '99.95vh', backgroundImage: 'URL('+mainimage+')', backgroundRepeat: 'no-repeat', backgroundSize:'cover'}}>
                <div>
                    <img
                        src={smartcommlogo}
                        alt="Small Image"
                        style={{height: '157px', width: '695px', marginTop: '300px'}}
                    />
                </div>
                <div style={{margin: '120px 160px 100px 160px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <div style={{width: '70px', height:'70px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <img
                            src={brandimage1}
                            alt="brand 1"
                            style={{marginBottom: '5px'}}
                        />
                        <Typography style={{color: '#FFFFFF'}}> Design </Typography>
                    </div>
                    <div style={{width: '70px', height:'70px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <img
                            src={brandimage2}
                            alt="brand 2"
                            style={{marginBottom: '5px'}}
                        />
                        <Typography style={{color: '#FFFFFF'}}> Build </Typography>
                    </div>
                    <div style={{width: '70px', height:'70px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <img
                            src={brandimage3}
                            alt="brand 3"
                            style={{marginBottom: '5px'}}
                        />
                        <Typography style={{color: '#FFFFFF'}}> Commission </Typography>
                    </div>
                    <div style={{width: '70px', height:'70px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <img
                            src={brandimage4}
                            alt="brand 4"
                            style={{marginBottom: '5px'}}
                        />
                        <Typography style={{color: '#FFFFFF'}}> Operate </Typography>
                    </div>
                    <div style={{width: '70px', height:'70px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <img
                            src={brandimage5}
                            alt="brand 5"
                            style={{marginBottom: '5px'}}
                        />
                        <Typography style={{color: '#FFFFFF'}}> Predict </Typography>
                    </div>
                </div>
                <div style={{color: '#FFFFFF', margin: '50px 250px 0px 250px'}}>
                    <p><i>
                        This software provides insights into energy patterns,
                        identifies opportunities for efficiency improvements, and
                        facilitates cost savings. It also enables better
                        decision-making, compliance with energy regulations , and
                        overall efforts.</i>
                    </p>
                </div>
            </div>
        </div>
    )
}